<template>
	<form @submit.prevent="handleSubmit">
		<integrations-form-field
			:field="fields.api"
			v-model="api"
		/>
		<label class="omapi-integrations-form__field-wrap">
			<div class="omapi-integrations-form__field-wrap-label">
				<span>{{ $get('fields.enterprise.label', 'Are you a GetResponse 360 customer?') }}</span>
			</div>
			<div class="omapi-integrations-form__field-wrap-field">
				<common-toggle-input
					class="omapi-input"
					wrapTag="span"
					onText="Yes"
					offText="No"
					name="enterprise"
					v-model="enterprise"
				/>
			</div>
		</label>
		<common-transition-slide :active="enterprise" @opened="resize" @closed="resize">
			<integrations-form-field
				:field="fields.domain"
				v-model="domain"
			/>
			<label class="omapi-integrations-form__field-wrap">
				<div class="omapi-integrations-form__field-wrap-label align-top">
					<common-tooltip :tooltip="countryFieldTooltip">
						<span>{{ $get('fields.country.label', 'What country is your account associated with?') }}</span>
					</common-tooltip>
				</div>
				<div class="omapi-integrations-form__field-wrap-field">
					<div class="omapi-radio-group omapi-input">
						<common-selectable-input
							v-for="(label, value) in options"
							:key="value"
							:value="value"
							:checked="value === country"
							type="radio"
							class="text-setting"
							name="country"
							:label="label"
							@input="country = $event.target.value"
						/>
						<p class="details">{{ countryFieldTooltip }}</p>
					</div>
				</div>
			</label>
		</common-transition-slide>
	</form>
</template>
<script>
import get from 'lodash/get'
import { bulkWatchHandler } from '@/utils'
import { altform } from '@/integrations/mixins/altform'

export default {
	mixins : [ altform ],
	props  : {
		/**
		 * Provider
		 */
		provider : {
			type : Object,
		},
	},
	data () {
		const fields = this.getFields()
		return {
			fields,
			options : get(fields, 'country.options', {
				US : 'United States',
				PL : 'Poland',
			}),
			api        : '',
			enterprise : false,
			domain     : '',
			country    : '',
		}
	},
	watch : {
		...bulkWatchHandler([ 'api', 'enterprise', 'domain', 'country' ], 'update'),
	},
	computed : {
		countryFieldTooltip () {
			return this.$get('fields.country.tooltip', 'Please ask a GetResponse account manager if you are unsure.')
		},
	},
	methods : {
		getFieldData () {
			return {
				api        : this.api,
				enterprise : this.enterprise,
				domain     : this.domain,
				country    : this.country,
			}
		},
	},
}
</script>
<style lang="scss" scoped>
.omapi-radio-group {
	margin-top: 0!important;
}
.details {
	font-size: 14px;
	margin-top: 20px;
}
</style>
